// export const soato_list = [
//   { id: 1703202, title: "Олтинкўл тумани" },
//   { id: 1703203, title: "Андижон тумани" },
//   { id: 1703206, title: "Балиқчи тумани" },
//   { id: 1703209, title: "Бўстон тумани" },
//   { id: 1703210, title: "Булоқбоши тумани" },
//   { id: 1703211, title: "Жалақудуқ тумани" },
//   { id: 1703214, title: "Избоскан тумани" },
//   { id: 1703217, title: "Улуғнор тумани" },
//   { id: 1703220, title: "Қўрғонтепа тумани" },
//   { id: 1703224, title: "Асака тумани" },
//   { id: 1703227, title: "Мархамат тумани" },
//   { id: 1703230, title: "Шахрихон тумани" },
//   { id: 1703232, title: "Пахтаобод тумани" },
//   { id: 1703236, title: "Хўжаобод тумани" },
//   { id: 1703401, title: "Андижон ш." },
//   { id: 1703408, title: "Хонобод" },
//   { id: 1706204, title: "Олот тумани" },
//   { id: 1706207, title: "Бухоро тумани" },
//   { id: 1706212, title: "Вобкент тумани" },
//   { id: 1706215, title: "Ғиждувон тумани" },
//   { id: 1706219, title: "Когон тумани" },
//   { id: 1706230, title: "Қоракўл тумани" },
//   { id: 1706232, title: "Қоровулбозор тумани" },
//   { id: 1706240, title: "Пешку тумани" },
//   { id: 1706242, title: "Ромитан тумани" },
//   { id: 1706246, title: "Жондор тумани" },
//   { id: 1706258, title: "Шофиркон тумани" },
//   { id: 1706401, title: "Бухоро ш." },
//   { id: 1706403, title: "Когон" },
//   { id: 1708201, title: "Арнасой тумани" },
//   { id: 1708204, title: "Бахмал тумани" },
//   { id: 1708209, title: "Ғаллаорол тумани" },
//   { id: 1708212, title: "Шароф Рашидов тумани" },
//   { id: 1708215, title: "Дўстлик тумани" },
//   { id: 1708218, title: "Зомин тумани" },
//   { id: 1708220, title: "Зарбдор тумани" },
//   { id: 1708223, title: "Мирзачўл тумани" },
//   { id: 1708225, title: "Зафаробод тумани" },
//   { id: 1708228, title: "Пахтакор тумани" },
//   { id: 1708235, title: "Фориш тумани" },
//   { id: 1708237, title: "Янгиобод тумани" },
//   { id: 1708401, title: "Жиззах ш." },
//   { id: 1710207, title: "Ғузор тумани" },
//   { id: 1710212, title: "Деҳқонобод тумани" },
//   { id: 1710220, title: "Қамаши тумани" },
//   { id: 1710224, title: "Қарши тумани" },
//   { id: 1710229, title: "Косон тумани" },
//   { id: 1710232, title: "Китоб тумани" },
//   { id: 1710233, title: "Миришкор тумани" },
//   { id: 1710234, title: "Муборак тумани" },
//   { id: 1710235, title: "Нишон тумани" },
//   { id: 1710237, title: "Касби тумани" },
//   { id: 1710240, title: "Кўкдала тумани" },
//   { id: 1710242, title: "Чироқчи тумани" },
//   { id: 1710245, title: "Шаҳрисабз тумани" },
//   { id: 1710250, title: "Яккабоғ тумани" },
//   { id: 1710401, title: "Қарши ш" },
//   { id: 1710405, title: "Шаҳрисабз" },
//   { id: 1712211, title: "Конимех тумани" },
//   { id: 1712216, title: "Қизилтепа тумани" },
//   { id: 1712230, title: "Навбаҳор тумани" },
//   { id: 1712234, title: "Кармана тумани" },
//   { id: 1712238, title: "Нурота тумани" },
//   { id: 1712244, title: "Томди тумани" },
//   { id: 1712248, title: "Учқудуқ тумани" },
//   { id: 1712251, title: "Хатирчи тумани" },
//   { id: 1712401, title: "Навоий ш." },
//   { id: 1712408, title: "Зарафшон" },
//   { id: 1712412, title: "Ғозғон" },
//   { id: 1714204, title: "Мингбулоқ тумани" },
//   { id: 1714207, title: "Косонсой тумани" },
//   { id: 1714212, title: "Наманган тумани" },
//   { id: 1714216, title: "Норин тумани" },
//   { id: 1714219, title: "Поп тумани" },
//   { id: 1714224, title: "Тўрақўрғон тумани" },
//   { id: 1714229, title: "Уйчи тумани" },
//   { id: 1714234, title: "Учқўрғон тумани" },
//   { id: 1714236, title: "Чортоқ тумани" },
//   { id: 1714237, title: "Чуст тумани" },
//   { id: 1714242, title: "Янгиқўрғон тумани" },
//   { id: 1714365, title: "Давлатобод тумани" },
//   { id: 1714367, title: "Янги Наманган тумани" },
//   { id: 1714401, title: "Наманган ш." },
//   { id: 1718203, title: "Оқдарё тумани" },
//   { id: 1718206, title: "Булунғур тумани" },
//   { id: 1718209, title: "Жомбой тумани" },
//   { id: 1718212, title: "Иштихон тумани" },
//   { id: 1718215, title: "Каттақўрғон тумани" },
//   { id: 1718216, title: "Қўшработ тумани" },
//   { id: 1718218, title: "Нарпай тумани" },
//   { id: 1718224, title: "Паяриқ тумани" },
//   { id: 1718227, title: "Пахтачи тумани" },
//   { id: 1718230, title: "Самарқанд тумани" },
//   { id: 1718233, title: "Нуробод тумани" },
//   { id: 1718235, title: "Ургут тумани" },
//   { id: 1718236, title: "Тайлоқ тумани" },
//   { id: 1718238, title: "Самарқанд ш." },
//   { id: 1718401, title: "Каттақўрғон" },
//   { id: 1722200, title: "Олтинсой тумани" },
//   { id: 1722201, title: "Ангор тумани" },
//   { id: 1722202, title: "Бандихон тумани" },
//   { id: 1722203, title: "Бойсун тумани" },
//   { id: 1722204, title: "Музработ тумани" },
//   { id: 1722207, title: "Денов тумани" },
//   { id: 1722210, title: "Жарқўрғон тумани" },
//   { id: 1722212, title: "Қумқўрғон тумани" },
//   { id: 1722214, title: "Қизириқ тумани" },
//   { id: 1722215, title: "Сариосиё тумани" },
//   { id: 1722217, title: "Термиз тумани" },
//   { id: 1722220, title: "Узун тумани" },
//   { id: 1722221, title: "Шеробод тумани" },
//   { id: 1722223, title: "Шўрчи тумани" },
//   { id: 1722226, title: "Термиз ш." },
//   { id: 1724200, title: "Оқолтин тумани" },
//   { id: 1724206, title: "Боёвут тумани" },
//   { id: 1724212, title: "Сайхунобод тумани" },
//   { id: 1724216, title: "Гулистон тумани" },
//   { id: 1724220, title: "Сардоба тумани" },
//   { id: 1724226, title: "Мирзаобод тумани" },
//   { id: 1724228, title: "Сирдарё тумани" },
//   { id: 1724231, title: "Ховос тумани" },
//   { id: 1724235, title: "Гулистон ш." },
//   { id: 1724401, title: "Ширин" },
//   { id: 1724410, title: "Янгиер" },
//   { id: 1726260, title: "Учтепа тумани" },
//   { id: 1726262, title: "Бектемир тумани" },
//   { id: 1726264, title: "Юнусобод тумани" },
//   { id: 1726266, title: "Мирзо Улуғбек тумани" },
//   { id: 1726269, title: "Миробод тумани" },
//   { id: 1726273, title: "Шайхонтохур тумани" },
//   { id: 1726277, title: "Олмазор тумани" },
//   { id: 1726280, title: "Сирғали тумани" },
//   { id: 1726283, title: "Яккасарой тумани" },
//   { id: 1726287, title: "Яшнобод тумани" },
//   { id: 1726290, title: "Янгихаёт райони" },
//   { id: 1726292, title: "Чилонзор тумани" },
//   { id: 1727200, title: "Оққўрғон тумани" },
//   { id: 1727206, title: "Оҳангарон тумани" },
//   { id: 1727212, title: "Бекобод тумани" },
//   { id: 1727220, title: "Бўстонлиқ тумани" },
//   { id: 1727224, title: "Бўка тумани" },
//   { id: 1727228, title: "Қийичирчиқ тумани" },
//   { id: 1727233, title: "Зангиота тумани" },
//   { id: 1727237, title: "Юқоричирчиқ тумани" },
//   { id: 1727239, title: "Қибрай тумани" },
//   { id: 1727248, title: "Паркент тумани" },
//   { id: 1727249, title: "Пскент тумани" },
//   { title: "Ўртачирчиқ тумани", id: 1727250 },
//   { title: "Чиноз тумани", id: 1727253 },
//   { title: "Янгиёъл тумани", id: 1727256 },
//   { title: "Тошкент тумани", id: 1727259 },
//   { title: "Нурафшон ш.", id: 1727265 },
//   { title: "Олмалиқ", id: 1727401 },
//   { title: "Ангрен", id: 1727404 },
//   { title: "Бекобод", id: 1727407 },
//   { title: "Оҳангарон", id: 1727413 },
//   { title: "Чирчиқ", id: 1727415 },
//   { title: "Янгиёъл", id: 1727419 },
//   { title: "Олтиариқ тумани", id: 1730200 },
//   { title: "Қўштепа тумани", id: 1730203 },
//   { title: "Боғдод тумани", id: 1730206 },
//   { title: "Бувайда тумани", id: 1730209 },
//   { title: "Бешариқ тумани", id: 1730212 },
//   { title: "Қува тумани", id: 1730215 },
//   { title: "Учкўприк тумани", id: 1730218 },
//   { title: "Риштон тумани", id: 1730221 },
//   { title: "Сўх тумани", id: 1730224 },
//   { title: "Тошлоқ тумани", id: 1730226 },
//   { title: "Ўзбекистон тумани", id: 1730227 },
//   { title: "Фарғона тумани", id: 1730230 },
//   { title: "Данғара тумани", id: 1730233 },
//   { title: "Фурқат тумани", id: 1730236 },
//   { title: "Ёзёвон тумани", id: 1730238 },
//   { title: "Фарғона ш.", id: 1730242 },
//   { title: "Қўқон", id: 1730401 },
//   { title: "Қувасой", id: 1730405 },
//   { title: "Марғилон", id: 1730408 },
//   { title: "Боғот тумани", id: 1733200 },
//   { title: "Гурлан тумани", id: 1733204 },
//   { title: "Қўшкўпир тумани", id: 1733208 },
//   { title: "Урганч тумани", id: 1733212 },
//   { title: "Хазорасп тумани", id: 1733217 },
//   { title: "Тупроққалъа тумани", id: 1733220 },
//   { title: "Тупроққалъа тумани", id: 1733221 },
//   { title: "Хонқа тумани", id: 1733221 },
//   { title: "Хива тумани", id: 1733223 },
//   { title: "Шовот тумани", id: 1733226 },
//   { title: "Янгиариқ тумани", id: 1733230 },
//   { title: "Янгибозор тумани", id: 1733233 },
//   { title: "Урганч ш.", id: 1733236 },
//   { title: "Хива", id: 1733401 },
//   { title: "Амударё тумани", id: 1735200 },
//   { title: "Беруний тумани", id: 1735204 },
//   { title: "Бўзатов тумани", id: 1735207 },
//   { title: "Қораўзак тумани", id: 1735209 },
//   { title: "Кегейли тумани", id: 1735211 },
//   { title: "Қўнғирот тумани", id: 1735212 },
//   { title: "Қанликўл тумани", id: 1735215 },
//   { title: "Мўйноқ тумани", id: 1735218 },
//   { title: "Нукус тумани", id: 1735222 },
//   { title: "Тахиатош тумани", id: 1735225 },
//   { title: "Тахтакўпир тумани", id: 1735228 },
//   { title: "Тўрткўл тумани", id: 1735230 },
//   { title: "Хўжайли тумани", id: 1735233 },
//   { title: "Чимбой тумани", id: 1735236 },
//   { title: "Шуманай тумани", id: 1735240 },
//   { title: "Елликкала тумани", id: 1735243 },
//   { title: "Нукус ш.", id: 1735250 },
// ];

export const soato_list = [
    {id: 1703202, title: "Олтинкўл тумани"},
    {id: 1703203, title: "Андижон тумани"},
    {id: 1703206, title: "Балиқчи тумани"},
    {id: 1703209, title: "Бўстон тумани"},
    {id: 1703210, title: "Булоқбоши тумани"},
    {id: 1703211, title: "Жалақудуқ тумани"},
    {id: 1703214, title: "Избоскан тумани"},
    {id: 1703217, title: "Улуғнор тумани"},
    {id: 1703220, title: "Қўрғонтепа тумани"},
    {id: 1703224, title: "Асака тумани"},
    {id: 1703227, title: "Мархамат тумани"},
    {id: 1703230, title: "Шахрихон тумани"},
    {id: 1703232, title: "Пахтаобод тумани"},
    {id: 1703236, title: "Хўжаобод тумани"},
    {id: 1703401, title: "Андижон ш."},
    {id: 1703408, title: "Хонобод"},
    {id: 1706204, title: "Олот тумани"},
    {id: 1706207, title: "Бухоро тумани"},
    {id: 1706212, title: "Вобкент тумани"},
    {id: 1706215, title: "Ғиждувон тумани"},
    {id: 1706219, title: "Когон тумани"},
    {id: 1706230, title: "Қоракўл тумани"},
    {id: 1706232, title: "Қоровулбозор тумани"},
    {id: 1706240, title: "Пешку тумани"},
    {id: 1706242, title: "Ромитан тумани"},
    {id: 1706246, title: "Жондор тумани"},
    {id: 1706258, title: "Шофиркон тумани"},
    {id: 1706401, title: "Бухоро ш."},
    {id: 1706403, title: "Когон"},
    {id: 1708201, title: "Арнасой тумани"},
    {id: 1708204, title: "Бахмал тумани"},
    {id: 1708209, title: "Ғаллаорол тумани"},
    {id: 1708212, title: "Шароф Рашидов тумани"},
    {id: 1708215, title: "Дўстлик тумани"},
    {id: 1708218, title: "Зомин тумани"},
    {id: 1708220, title: "Зарбдор тумани"},
    {id: 1708223, title: "Мирзачўл тумани"},
    {id: 1708225, title: "Зафаробод тумани"},
    {id: 1708228, title: "Пахтакор тумани"},
    {id: 1708235, title: "Фориш тумани"},
    {id: 1708237, title: "Янгиобод тумани"},
    {id: 1708401, title: "Жиззах ш."},
    {id: 1710207, title: "Ғузор тумани"},
    {id: 1710212, title: "Деҳқонобод тумани"},
    {id: 1710220, title: "Қамаши тумани"},
    {id: 1710224, title: "Қарши тумани"},
    {id: 1710229, title: "Косон тумани"},
    {id: 1710232, title: "Китоб тумани"},
    {id: 1710233, title: "Миришкор тумани"},
    {id: 1710234, title: "Муборак тумани"},
    {id: 1710235, title: "Нишон тумани"},
    {id: 1710237, title: "Касби тумани"},
    {id: 1710240, title: "Кўкдала тумани"},
    {id: 1710242, title: "Чироқчи тумани"},
    {id: 1710245, title: "Шаҳрисабз тумани"},
    {id: 1710250, title: "Яккабоғ тумани"},
    {id: 1710401, title: "Қарши ш.. "},
    {id: 1710405, title: "Шаҳрисабз"},
    {id: 1712211, title: "Конимех тумани"},
    {id: 1712216, title: "Қизилтепа тумани"},
    {id: 1712230, title: "Навбаҳор тумани"},
    {id: 1712234, title: "Кармана тумани"},
    {id: 1712238, title: "Нурота тумани"},
    {id: 1712244, title: "Томди тумани"},
    {id: 1712248, title: "Учқудуқ тумани"},
    {id: 1712251, title: "Хатирчи тумани"},
    {id: 1712401, title: "Навоий ш."},
    {id: 1712408, title: "Зарафшон"},
    {id: 1712412, title: "Ғозғон"},
    {id: 1714204, title: "Мингбулоқ тумани"},
    {id: 1714207, title: "Косонсой тумани"},
    {id: 1714212, title: "Наманган тумани"},
    {id: 1714216, title: "Норин тумани"},
    {id: 1714219, title: "Поп тумани"},
    {id: 1714224, title: "Тўрақўрғон тумани"},
    {id: 1714229, title: "Уйчи тумани"},
    {id: 1714234, title: "Учқўрғон тумани"},
    {id: 1714236, title: "Чортоқ тумани"},
    {id: 1714237, title: "Чуст тумани"},
    {id: 1714242, title: "Янгиқўрғон тумани"},
    {id: 1714365, title: "Давлатобод тумани"},
    {id: 1714367, title: "Янги Наманган тумани"},
    {id: 1714401, title: "Наманган ш."},
    {id: 1718203, title: "Оқдарё тумани"},
    {id: 1718206, title: "Булунғур тумани"},
    {id: 1718209, title: "Жомбой тумани"},
    {id: 1718212, title: "Иштихон тумани"},
    {id: 1718215, title: "Каттақўрғон тумани"},
    {id: 1718216, title: "Қўшработ тумани"},
    {id: 1718218, title: "Нарпай тумани"},
    {id: 1718224, title: "Паяриқ тумани"},
    {id: 1718227, title: "Пастдарғом тумани"},
    {id: 1718230, title: "Пахтачи тумани"},
    {id: 1718233, title: "Самарқанд тумани"},
    {id: 1718235, title: "Нуробод тумани"},
    {id: 1718236, title: "Ургут тумани"},
    {id: 1718238, title: "Тайлоқ тумани"},
    {id: 1718401, title: "Самарқанд ш."},
    {id: 1718406, title: "Каттақўрғон"},
    {id: 1722201, title: "Олтинсой тумани"},
    {id: 1722202, title: "Ангор тумани"},
    {id: 1722203, title: "Бандихон тумани"},
    {id: 1722204, title: "Бойсун тумани"},
    {id: 1722207, title: "Музработ тумани"},
    {id: 1722210, title: "Денов тумани"},
    {id: 1722212, title: "Жарқўрғон тумани"},
    {id: 1722214, title: "Қумқўрғон тумани"},
    {id: 1722215, title: "Қизириқ тумани"},
    {id: 1722217, title: "Сариосиё тумани"},
    {id: 1722220, title: "Термиз тумани"},
    {id: 1722221, title: "Узун тумани"},
    {id: 1722223, title: "Шеробод тумани"},
    {id: 1722226, title: "Шўрчи тумани"},
    {id: 1722401, title: "Термиз ш."},
    {id: 1724206, title: "Оқолтин тумани"},
    {id: 1724212, title: "Боёвут тумани"},
    {id: 1724216, title: "Сайхунобод тумани"},
    {id: 1724220, title: "Гулистон тумани"},
    {id: 1724226, title: "Сардоба тумани"},
    {id: 1724228, title: "Мирзаобод тумани"},
    {id: 1724231, title: "Сирдарё тумани"},
    {id: 1724235, title: "Ховос тумани"},
    {id: 1724401, title: "Гулистон ш."},
    {id: 1724410, title: "Ширин"},
    {id: 1724413, title: "Янгиер"},
    {id: 1726262, title: "Учтепа тумани"},
    {id: 1726264, title: "Бектемир тумани"},
    {id: 1726266, title: "Юнусобод тумани"},
    {id: 1726269, title: "Мирзо Улуғбек тумани"},
    {id: 1726273, title: "Миробод тумани"},
    {id: 1726277, title: "Шайхонтохур тумани"},
    {id: 1726280, title: "Олмазор тумани"},
    {id: 1726283, title: "Сирғали тумани"},
    {id: 1726287, title: "Яккасарой тумани"},
    {id: 1726290, title: "Яшнобод тумани"},
    {id: 1726292, title: "Янгихаёт райони"},
    {id: 1726294, title: "Чилонзор тумани"},
    {id: 1727206, title: "Оққўрғон тумани"},
    {id: 1727212, title: "Оҳангарон тумани"},
    {id: 1727220, title: "Бекобод тумани"},
    {id: 1727224, title: "Бўстонлиқ тумани"},
    {id: 1727228, title: "Бўка тумани"},
    {id: 1727233, title: "Қийичирчиқ тумани"},
    {id: 1727237, title: "Зангиота тумани"},
    {id: 1727239, title: "Юқоричирчиқ тумани"},
    {id: 1727248, title: "Қибрай тумани"},
    {id: 1727249, title: "Паркент тумани"},
    {id: 1727250, title: "Пскент тумани"},
    {id: 1727253, title: "Ўртачирчиқ тумани"},
    {id: 1727256, title: "Чиноз тумани"},
    {id: 1727259, title: "Янгиёъл тумани"},
    {id: 1727265, title: "Тошкент тумани"},
    {id: 1727401, title: "Нурафшон ш."},
    {id: 1727404, title: "Олмалиқ"},
    {id: 1727407, title: "Ангрен"},
    {id: 1727413, title: "Бекобод"},
    {id: 1727415, title: "Оҳангарон"},
    {id: 1727419, title: "Чирчиқ"},
    {id: 1727424, title: "Янгиёъл"},
    {id: 1730203, title: "Олтиариқ тумани"},
    {id: 1730206, title: "Қўштепа тумани"},
    {id: 1730209, title: "Боғдод тумани"},
    {id: 1730212, title: "Бувайда тумани"},
    {id: 1730215, title: "Бешариқ тумани"},
    {id: 1730218, title: "Қува тумани"},
    {id: 1730221, title: "Учкўприк тумани"},
    {id: 1730224, title: "Риштон тумани"},
    {id: 1730226, title: "Сўх тумани"},
    {id: 1730227, title: "Тошлоқ тумани"},
    {id: 1730230, title: "Ўзбекистон тумани"},
    {id: 1730233, title: "Фарғона тумани"},
    {id: 1730236, title: "Данғара тумани"},
    {id: 1730238, title: "Фурқат тумани"},
    {id: 1730242, title: "Ёзёвон тумани"},
    {id: 1730401, title: "Фарғона ш."},
    {id: 1730405, title: "Қўқон"},
    {id: 1730408, title: "Қувасой"},
    {id: 1730412, title: "Марғилон"},
    {id: 1733204, title: "Боғот тумани"},
    {id: 1733208, title: "Гурлан тумани"},
    {id: 1733212, title: "Қўшкўпир тумани"},
    {id: 1733217, title: "Урганч тумани"},
    {id: 1733220, title: "Хазорасп тумани"},
    {id: 1733221, title: "Тупроққалъа тумани"},
    {id: 1733221, title: "Тупроққалъа тумани"},
    {id: 1733223, title: "Хонқа тумани"},
    {id: 1733226, title: "Хива тумани"},
    {id: 1733230, title: "Шовот тумани"},
    {id: 1733233, title: "Янгиариқ тумани"},
    {id: 1733236, title: "Янгибозор тумани"},
    {id: 1733401, title: "Урганч ш."},
    {id: 1733406, title: "Хива"},
    {id: 1735204, title: "Амударё тумани"},
    {id: 1735207, title: "Беруний тумани"},
    {id: 1735209, title: "Бўзатов тумани"},
    {id: 1735211, title: "Қораўзак тумани"},
    {id: 1735212, title: "Кегейли тумани"},
    {id: 1735215, title: "Қўнғирот тумани"},
    {id: 1735218, title: "Қанликўл тумани"},
    {id: 1735222, title: "Мўйноқ тумани"},
    {id: 1735225, title: "Нукус тумани"},
    {id: 1735228, title: "Тахиатош тумани"},
    {id: 1735230, title: "Тахтакўпир тумани"},
    {id: 1735233, title: "Тўрткўл тумани"},
    {id: 1735236, title: "Хўжайли тумани"},
    {id: 1735240, title: "Чимбой тумани"},
    {id: 1735243, title: "Шуманай тумани"},
    {id: 1735250, title: "Елликкала тумани"},
    {id: 1735401, title: "Нукус ш."},
];


export const work_types = [
    {id: 1, title: "Қурилиш"},
    {id: 2, title: "Жиҳоз"},
    {id: 3, title: "Шаҳарсозлик ҳужжатлари"},
    {id: 4, title: "Техника"},
    // { id: 9, title: "Жорий таъмирлаш" },
];

export const object_power_types = [
    {id: 1, title: "объект"},
    {id: 2, title: "ётоқ жой"},
    {id: 3, title: "ўқув ўрин"},
    {id: 5, title: "тик дренаж қудуқ, дона"},
    {id: 39, title: "комплекс"},
    {id: 6, title: "объект, дона"},
    {id: 7, title: "км"},
    {id: 40, title: "коллектор, км"},
    {id: 41, title: "лоток, км"},
    {id: 8, title: "насос станция, м3/сек"},
    {id: 9, title: "млн.м3"},
    {id: 10, title: "ўрин"},
    {id: 42, title: "канал, км"},
    {id: 43, title: "суғориш қудуғи, дона"},
    {id: 11, title: "қатнов"},
    {id: 44, title: "суғориш тармоқлари, км"},
    {id: 12, title: "хонадон"},
    {id: 13, title: "пм"},
    {id: 45, title: "насос станция, дона"},
    {id: 14, title: "ГТИ, дона"},
    {id: 16, title: "ўқув ўрни"},
    {id: 18, title: "объект, дона"},
    {id: 19, title: "кўприк, дона"},
    {id: 20, title: "ЁЁД, км"},
    {id: 22, title: "канал, км"},
    {id: 24, title: "кузатув қудуқ, дона"},
    {id: 25, title: "дона"},
    {id: 26, title: "ГТИ, дан"},
    {id: 27, title: "насос станция, дона"},
    {id: 28, title: "дамба, км"},
    {id: 29, title: "босмлий қувур, км"},
    {id: 30, title: "тик қудуқ, дона"},
    {id: 32, title: "кузатув пункти"},
    {id: 33, title: "оқава сув иншооти"},
    {id: 34, title: "спорт зал"},
    {id: 35, title: "ошхона"},
    {id: 37, title: "лоток, км"},
    {id: 38, title: "босмлий қувур, км"},
];

export const ministries = [
    {id: 1, title: "Ўзбекистон Республикаси Президенти Администрацияси "},
    {id: 2, title: "Вазирлар Маҳкамаси"},
    {id: 3, title: "Иқтисодиёт ва молия вазирлиги"},
    {id: 4, title: "Ёшлар сиёсати ва спорт вазирлиги"},
    {id: 5, title: "Қурилиш ва уй-жой коммунал хўжалиги вазирлиги"},
    {id: 6, title: "Соғлиқни сақлаш вазирлиги"},
    {id: 7, title: "Маданият ва туризм вазирлиги"},
    {id: 8, title: "Транспорт вазирлиги"},
    {id: 9, title: "Вилоят ҳокимликлари"},
    {id: 10, title: "Мактабгача ва мактаб таълими вазирлиги"},
    {id: 11, title: "Олий таълим, фан ва инновациялар вазирлиги"},
    {id: 12, title: "Ташқи ишлар вазирлиги"},
    {id: 13, title: "Ички ишлар вазирлиги"},
    {id: 14, title: "Сув хўжалиги вазирлиги"},
    {id: 15, title: "Мудофаа вазирлиги"},
    {id: 16, title: "Фавқулодда вазиятлар вазирлиги"},
    {id: 17, title: "Табиат ресурслари вазирлиги"},
    {id: 18, title: "Инвестициялар,}, саноат ва савдо вазирлиги"},
    {id: 19, title: "Камбағалликни қисқартириш ва бандлик вазирлиги"},
    {id: 20, title: "Қишлоқ хўжалиги вазирлиги"},
    {id: 21, title: "Тоғ-кон саноати ва геология вазирлиги"},
    {id: 22, title: "Рақамли технологиялар вазирлиги"},
    {id: 23, title: "Адлия вазирлиги"},
    {id: 24, title: "Энергетика вазирлиги"},
    {id: 25, title: "Олий Суд"},
    {id: 26, title: "Бош прократура"},
    {id: 27, title: "Миллий гвардия"},
    {id: 28, title: "Давлат хавфсизлик хизмати"},
    {id: 29, title: "Ўзбекистон Миллий телерадио компанияси"},
    {
        id: 30,
        title:
            "Рақобатни ривожлантириш ва истеъмолчилар ҳуқуқларини ҳимоя қилиш қўмитаси",
    },
    {id: 31, title: "Дин ишлари бўйича қўмита"},
    {id: 32, title: "Давлат активларини бошқариш агентлиги"},
    {id: 33, title: "Миллий антидопинг агентлиги"},
    {id: 34, title: "Маданий мерос агентлиги"},
    {id: 35, title: "Мудофаа саноати агентлиги"},
    {id: 36, title: "Ҳудудий электр тармоқлари АЖ"},
    {id: 37, title: "Ҳудудгазтаъминот АЖ"},
    {id: 38, title: "Ўзтрансгаз АЖ"},
    {id: 39, title: "Ўзбекистон Бадиий академияси"},
    {id: 40, title: "Касаба уюшмалари федерацияси"},
    {id: 41, title: "Фанлар Академияси"},
    {id: 42, title: "Жисмоний тарбия ва спорт вазирлиги"},
    {id: 43, title: "Ахборот техналогиялари вазирлиги"},
];

export const funding_sources = [
    {id: 3, title: "Ссуда"},
    {id: 1, title: "Республика бюджети"},
    {id: 2, title: "Маҳаллий бюджет"},
    {id: 5, title: "Тадбиркорлик жамғармаси"},
    {id: 4, title: "Бюджетдан ташқари жамғарма"},
];

export const expense_types = [
    {id: 1, title: "Тақсимланган"},
    {id: 2, title: "Тақсимланмаган"},
    {id: 3, title: "Ссуда"},
];


export const construction_types = [
    {id: 1, title: "Қурилиш"},
    {id: 2, title: "Жиҳоз"},
    {id: 3, title: "Шаҳарсозлик ҳужжатлари"},
    {id: 4, title: "Техника"},
    {id: 9, title: "Жорий таъмирлаш"},
];

export const construction_types_new = [
    {id: 9, title: "Жорий таъмирлаш"},
    {id: 1, title: "Янги қурилиш"},
    {id: 2, title: "Реконструкция"},
    {id: 3, title: "Таъмирлаш"},
    {id: 4, title: "Келгуси йил объектининг лойиҳа-қидирув ишлари"},
    {id: 5, title: "Кредитор қарздорлик"},
    {id: 6, title: "Модернизация"},
    {id: 7, title: "Жиҳоз"},
    {id: 8, title: "Мукаммал таъмир"},
];

export const spheres_list = [
    {id: 1, title: "Ижтимоий соҳалар"},
    {id: 2, title: "Муҳандислик-коммуникация тармоқлари"},
    {id: 3, title: "Йўл-транспорт инфратузилмаси"},
    {id: 4, title: "Ирригация ва мелиорация"},
    {
        id: 5,
        title:
            "Махсус иқтисодий зоналар, кичик саноат зоналари, ёшлар саноат ва тадбиркорлик зоналари ҳамда йирик ишлаб чиқариш лойиҳаларини ташқи муҳандислик-коммуникация тармоқлари билан таъминлаш",
    },
    {
        id: 6,
        title:
            "Ҳудудий, муҳандислик-инфратузилма, шунингдек алоҳида муҳим ва тоифаланган объектларни қуриш ҳамда реконструкция қилиш",
    },
    {id: 7, title: "Бошқа йўналишлар"},
    {
        id: 8,
        title:
            "Туризм объектлари атрофидаги ер майдонлари, сув ва йўл инфратузилмаларини яхшилаш",
    },
    {
        id: 9,
        title:
            "«Янги Ўзбекистон» массивларида барпо этиладиган инфратузилма объектлари учун",
    },
];

export const networks_list = [
    {id: 1, sphere_id: 1, title: "Умумтаълим мактаблари"},
    {id: 2, sphere_id: 1, title: "Ижод ва ихтисослаштирилган мактаблар"},
    {id: 3, sphere_id: 1, title: "Мактабгача таълим ташкилотлари"},
    {
        id: 4,
        sphere_id: 1,
        title: "Соғлиқни сақлаш ва тиббий-ижтимоий муассасалар",
    },
    {id: 5, sphere_id: 1, title: "Олий таълим муассасалари"},
    {id: 6, sphere_id: 1, title: "Спорт объектлари"},
    {id: 7, sphere_id: 1, title: "Маданият ва санъат"},
    {id: 8, sphere_id: 1, title: "Илм-фан ва инновация"},
    {id: 9, sphere_id: 8, title: "Туризм объектлари"},
    {id: 10, sphere_id: 2, title: "Сув таъминоти ва канализация"},
    {id: 11, sphere_id: 2, title: "Иссиқлик таъминоти"},
    {
        id: 12,
        sphere_id: 3,
        title: "Автомобиль йўллари, кўприклар ва йўл ўтказгичлар",
    },
    {id: 13, sphere_id: 3, title: "Темир йўл транспорти ва метро"},
    {id: 14, sphere_id: 4, title: "Ирригация тармоқлари ва иншоотлари"},
    {id: 15, sphere_id: 4, title: "Мелиорация тармоқлари ва иншоотлари"},
    {
        id: 16,
        sphere_id: 5,
        title:
            "Махсус иқтисодий зоналар, кичик саноат зоналари, ёшлар саноат ва тадбиркорлик зоналари ҳамда йирик ишлаб чиқариш лойиҳаларининг ташқи муҳандислик-коммуникация тармоқлари",
    },
    {
        id: 17,
        sphere_id: 7,
        title: "Мудофаа ва ҳуқуқни муҳофаза қилувчи органлар",
    },
    {id: 18, sphere_id: 7, title: "Ёпиқ қисм"},
    {
        id: 19,
        sphere_id: 6,
        title:
            "Ҳудудий, муҳандислик-инфратузилма, шунингдек, алоҳида муҳим ва тоифаланган объектларни қуриш ҳамда реконструкция қилиш",
    },
    {
        id: 20,
        sphere_id: 9,
        title:
            "«Янги Ўзбекистон» массивларида барпо этиладиган инфратузилма объектлари учун",
    },
    {id: 22, sphere_id: 6, title: "Қирғоқ бўйи ва бошқа ҳимоя иншоотлар"},
    {
        id: 23,
        sphere_id: 6,
        title:
            "Туман марказлари ва шаҳарларнинг меъморий қиёфасини замонавийлаштириш",
    },
    {id: 25, sphere_id: 1, title: "Маданий мерос объектлари"},
    {id: 26, sphere_id: 2, title: "Электр энергия тармоғини қуриш"},
    {id: 27, sphere_id: 2, title: "Газ тармоғини қуриш"},
    {id: 29, sphere_id: 2, title: "Бошқалар"},
    {
        id: 32,
        sphere_id: 6,
        title: "Кўп қаватли уй жойлар қурилиши ва уларни модернизация қилиш",
    },
    {
        id: 33,
        sphere_id: 6,
        title:
            "Давлат-хусусий шериклик шартлари асосида лойиҳаларни амалга оширишни биргаликда молиялаштириш",
    },
    {id: 38, sphere_id: 2, title: "Алоқа тармоғларини қуриш"},
];


export const categoryWithIds = {
    1: {
        sphere_id: 1,
        network_id: 3,
        ministry_id: 10
    },
    2: {
        sphere_id: 1,
        network_id: 1,
        ministry_id: 10
    },
    3: {
        sphere_id: 1,
        network_id: 2,
        ministry_id: 10
    },
    4: {
        sphere_id: 1,
        network_id: 2,
        ministry_id: 5
    },
    5: {
        sphere_id: 1,
        network_id: 6,
        ministry_id: 4
    },
    6: {
        sphere_id: 1,
        network_id: 4,
        ministry_id: 6
    },
    7: {
        sphere_id: 6,
        network_id: 19,
        ministry_id: 4
    },
    8: {
        sphere_id: 1,
        network_id: 19,
        ministry_id: 5
    },
    9: {
        sphere_id: 2,
        network_id: 26,
        ministry_id: 36
    },
    10: {
        sphere_id: 2,
        network_id: 10,
        ministry_id: 14
    },
    11: {
        sphere_id: 3,
        network_id: 12,
        ministry_id: 8
    },
    12: {
        sphere_id: 2,
        network_id: 10,
        ministry_id: 14
    },
    13: {
        sphere_id: 6,
        network_id: 19,
        ministry_id: 5
    },
    14: {
        sphere_id: 6,
        network_id: 19,
        ministry_id: 5
    },
    15: {
        sphere_id: 2,
        network_id: 19,
        ministry_id: 5
    },
    16: {
        sphere_id: 6,
        network_id: 19,
        ministry_id: 5
    },
    17: {
        sphere_id: 1,
        network_id: 5,
        ministry_id: 11
    },
    18: {
        sphere_id: 2,
        network_id: 27,
        ministry_id: 37
    },
    20: {
    sphere_id: 2,
    network_id: 26,
    ministry_id: 24,
  },
}
